import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden mb-2">
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between p-4 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-left"
    >
      <span className="font-medium text-gray-900 dark:text-white">{title}</span>
      <SafeIcon icon={isOpen ? FiChevronUp : FiChevronDown} className="text-gray-500" />
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className="p-4 bg-gray-50 dark:bg-gray-900/50 text-gray-600 dark:text-gray-300 text-sm leading-relaxed border-t border-gray-200 dark:border-gray-700">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Education = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const items = [
    {
      title: 'What is BMR?',
      content: 'Basal Metabolic Rate (BMR) is the number of calories your body burns while at rest to maintain basic life functions like breathing, circulation, and cell production. It accounts for about 60-75% of your total daily energy expenditure.'
    },
    {
      title: 'What is TDEE?',
      content: 'Total Daily Energy Expenditure (TDEE) is the total number of calories you burn in a day. It includes your BMR plus calories burned through physical activity (exercise and daily movement) and the thermic effect of food (digestion).'
    },
    {
      title: 'Why results may seem off?',
      content: 'Calculators are estimations based on population averages. Individual metabolism can vary due to genetics, history of dieting (metabolic adaptation), and body composition. Use these numbers as a starting point and adjust based on real-world progress over 2-3 weeks.'
    },
    {
      title: 'Long-Term Fat Loss Strategy',
      content: 'Sustainable fat loss takes time. A moderate deficit (15-20%) preserves muscle mass and metabolic health. "Crash dieting" often leads to muscle loss and rapid rebound weight gain. Patience and consistency are key.'
    }
  ];

  return (
    <div className="mt-12">
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
        <span>📚</span> Knowledge Base
      </h3>
      {items.map((item, idx) => (
        <AccordionItem
          key={idx}
          title={item.title}
          isOpen={openIndex === idx}
          onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Education;